// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2DtEh","choiceBoxes":"toolbarselects_choiceBoxes__1RPwq","simpleField":"toolbarselects_simpleField__lyQmc"};